import { ActionRegistryCategory } from '../../../registry/action/ActionRegistryCategory';
import { ActionRegistryItem } from '../../../registry/action/ActionRegistryItem';
export class ActionsOrderedTask extends ActionRegistryCategory {
    label = 'Ordered Task';
    constructor(parent) {
        super(parent);
        super.init();
    }
    selectOrderedOption = () => new ActionRegistryItem({
        label: 'Option auswählen',
        action: ({ question, option, orderedTask, event }) => {
            if (!question || !option)
                return;
            if (!orderedTask.taskProgress.isTaskCompleted && !!orderedTask.step) {
                const step = orderedTask.step;
                step.selectionEvents.unshift(event);
                if (document.activeElement instanceof HTMLElement)
                    document.activeElement.blur();
                setTimeout(() => option.actorEvents.fireEvent({ type: 'optionwasselected' }));
                if (step.stepEval.isWronglySelected) {
                    question.answeringStepMistake.trackMistake();
                }
                if (step.stepEval.isNowCorrectlySelected) {
                    question.answeringStepCorrect.trackCorrect();
                }
            }
        },
    });
}
